import router from '@/router';
import Axios from 'axios';
import store from '../../store/store';
import { SET_USER_DETAILS } from '@/store/MutationTypes';
import UserDetails from '@/models/User/UserDetails';
import { UserTypes } from '@/models/User/UserTypes';

const baseURL = process.env.VUE_APP_BASE_DOMAIN + process.env.VUE_APP_BASE_DIRECTORY;

const repository = Axios.create({
    baseURL,
    // headers: {'Authorization' : ''}
});

repository.interceptors.response.use(
    (response) => response,
    (err: any) => {
        if (err.response) {
            if (err.response.status === 401) {

                store.commit(SET_USER_DETAILS, {
                    userDetails: new UserDetails(UserTypes.Guest, '', ''),
                    logged: false,
                });
                router.push('/login');
            }

            // check if subscription or trial is expired
            if (err.response.status === 402) {
                router.push('/subscription');
            }

            if (err.response.status === 403) {
                router.push('/');
            }

            return Promise.reject(err);
        }    
    });

export default repository;
